import { Box, LinearProgress, Typography } from '@mui/material'

import React from 'react'

interface JobProgressBarProps {
  flowStatus: {
    dependant_jobs: {
      completed: number
      failed: number
      total: number
    }
    worker_jobs: {
      completed: number
      failed: number
      total: number
    }
  }
}

export function JobProgressBar({ flowStatus }: JobProgressBarProps) {
  if (!flowStatus) return null

  const { dependant_jobs, worker_jobs } = flowStatus
  const totalJobs = dependant_jobs.total + worker_jobs.total
  const completedJobs = dependant_jobs.completed + worker_jobs.completed
  const failedJobs = dependant_jobs.failed + worker_jobs.failed

  if (totalJobs === 0) return null

  const progress = (completedJobs / totalJobs) * 100
  const hasErrors = failedJobs > 0

  return (
    <Box sx={{ width: '100%', mt: 1 }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={1}
      >
        <Typography variant="body2" color="text.secondary">
          Job Progress
        </Typography>
        <Typography
          variant="body2"
          color={hasErrors ? 'error.main' : 'text.secondary'}
        >
          {completedJobs}/{totalJobs} completed
          {hasErrors ? ` (${failedJobs} failed)` : ''}
        </Typography>
      </Box>
      <LinearProgress
        variant="determinate"
        value={progress}
        color={hasErrors ? 'error' : 'primary'}
        sx={{
          height: 8,
          borderRadius: 4,
          backgroundColor: 'grey.200',
          '& .MuiLinearProgress-bar': {
            borderRadius: 4,
          },
        }}
      />
    </Box>
  )
}
